import { createAsyncThunk } from '@reduxjs/toolkit';
import { InitialIdentityState, ProfileIdReqType } from '../../../types';
import { identityApi } from '../../requests';
import { StepupChallengeResponse } from '../../models/StepupChallengeResponse';
export const generateChallengeIdForUpdatePasswordThunk = createAsyncThunk<
  StepupChallengeResponse,
  ProfileIdReqType,
  {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    dispatch: any;
    extra: {
      BASE_API_URL: string;
    };
    state: InitialIdentityState;
  }
>('commerceIdentity/generateChallengeIdForUpdatePasswordThunk', async ({ profileId }) => {
  const res = await identityApi.generateChallengeIdForUpdatePassword({
    profileId,
  });
  return res;
});
